// @ts-nocheck aa2cb4fc
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['design_section_label_explore_button'],
      sections: [addPanel.sections.getSections().button.textButtonsSection],
    };
  },
};
